import CompanyAffiliatesScreen from './CompanyAffiliatesScreen';

export default CompanyAffiliatesScreen;
